



























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class ProfilePlaceholder extends Vue {
  @Prop({ default: '' }) header;
  @Prop({ default: '' }) subHeader;
  @Prop({ default: '' }) image;
  @Prop({ default: '' }) linkText;
  @Prop({ default: () => {} }) onLinkClick;
}
